export default "__VITE_ASSET__BJ0c2sKJ__"